/* Lazy-mount de bloco de app (hoje: widget de avaliações do Loox).
 *
 * O bloco vem do Liquid dentro de <template data-ohli-lazy-app-content> —
 * DOM inerte, nada dele carrega. Quando o wrapper [data-ohli-lazy-app] chega
 * a `data-ohli-lazy-margin` px abaixo da tela, o conteúdo é clonado para o
 * DOM. O próprio script do Loox monta o widget em seguida (ele procura
 * #looxReviews a cada 1s — comportamento dele, verificado em 01/set/2026).
 *
 * Sem IntersectionObserver (browsers antigos): monta na hora, sem perda.
 * Ver sections/ohli-reviews.liquid para o porquê e o PLANO-PERF-SET2026.md.
 */
(function () {
  'use strict';

  function montar(wrap) {
    var tpl = wrap.querySelector('template[data-ohli-lazy-app-content]');
    if (!tpl) return;
    wrap.appendChild(tpl.content.cloneNode(true));
    tpl.parentNode.removeChild(tpl);
    wrap.setAttribute('data-ohli-lazy-app-mounted', '');
  }

  function iniciar() {
    var wraps = document.querySelectorAll('[data-ohli-lazy-app]');
    if (!wraps.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(wraps, montar);
      return;
    }
    Array.prototype.forEach.call(wraps, function (wrap) {
      var margem = parseInt(wrap.getAttribute('data-ohli-lazy-margin'), 10);
      if (isNaN(margem)) margem = 300;
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              io.disconnect();
              montar(wrap);
              return;
            }
          }
        },
        { rootMargin: margem + 'px 0px' }
      );
      io.observe(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
